/**
 * Opens the automation's workflow in the fullscreen builder: where its
 * inputs (Start step) and its response fields (End step) are defined.
 */
import { useServiceOptional } from '@toeverything/infra';
import { useCallback } from 'react';

import { EditorService } from '../../../editor';
import type { AutomationConfig } from '../../services/automation';

export function openWorkflowBuilder(
  editor:
    | { openWorkflowFullscreen: (id: string, name: string) => void }
    | null
    | undefined,
  workflowId: string,
  workflowName: string
) {
  if (editor) {
    editor.openWorkflowFullscreen(workflowId, workflowName);
    return;
  }
  window.dispatchEvent(
    new CustomEvent('streamlain:workflow-fullscreen', {
      detail: { workflowId, workflowName },
    })
  );
}

/** Opens the selected workflow; null while no workflow is selected. */
export function useOpenWorkflow(
  config: Pick<AutomationConfig, 'workflowId' | 'workflowName'>
): (() => void) | null {
  const editor = useServiceOptional(EditorService)?.editor;
  const { workflowId, workflowName } = config;
  const open = useCallback(() => {
    if (workflowId) openWorkflowBuilder(editor, workflowId, workflowName ?? '');
  }, [editor, workflowId, workflowName]);
  return workflowId ? open : null;
}
